import { PortfolioItem } from '../types/content';
import { images } from './images';

export const portfolio: PortfolioItem[] = [
  { id: 'p01', title: 'The Keywork Heavens Fence Tattoo', image: images.knight },
  { id: 'p02', title: 'Dolphin Tattoo', image: images.dolphin },
  { id: 'p03', title: 'Custom Fingerprint Tattoo', image: images.heart },
  { id: 'p04', title: 'Cartoon Tattoo', image: images.cupcake },
  { id: 'p05', title: 'Skill Knuckle Tattoo', image: images.skull },
  { id: 'p06', title: 'Seeds Eggs Skull Tattoo Art', image: images.skull },
  { id: 'p07', title: 'Red Monkey Tattoo', image: images.fish, artist: 'Jeff Parkway' },
  { id: 'p08', title: 'Hen Cock Tattoo Art', image: images.snake },
  { id: 'p09', title: 'Finger Ring Tattoo', image: images.heart },
  { id: 'p10', title: 'Custom Fingerprint Tattoo', image: images.sunflower },
  { id: 'p11', title: 'Girl Playing Aeroplane Arm Tattoo', image: images.cupcake },
  { id: 'p12', title: 'Vampire Teeth Angry Arm Tattoo', image: images.knight },
  { id: 'p13', title: 'Snake Cobra Arm Tattoo', image: images.snake },
  { id: 'p14', title: 'Skull With Nails Tattoo Art Chest', image: images.skull },
  { id: 'p15', title: 'Skull Hat Tuxedo Tattoo Art', image: images.skull },
  { id: 'p16', title: 'Skull Bones Arm Tattoo Realistic', image: images.knight },
  { id: 'p17', title: 'Knight Sword Dark Arm Tattoo', image: images.knight },
  { id: 'p18', title: 'Horror Skull Girl Tattoo Artwork Leg', image: images.skull },
  { id: 'p19', title: 'Hand Bones Realistic Tattoo', image: images.knight },
  { id: 'p20', title: 'Fish Hook Tattoo Art', image: images.fish },
  { id: 'p21', title: 'Dolphin Tattoo', image: images.dolphin },
  { id: 'p22', title: 'Custom Fingerprint Tattoo', image: images.heart },
  { id: 'p23', title: 'Cartoon Tattoo', image: images.cupcake },
  { id: 'p24', title: 'Wings Roses Jewel Heart Tattoo', image: images.heart, artist: 'Rain' },
  { id: 'p25', title: 'Winged Tire Skull Tattoo', image: images.skull, artist: 'Osker' },
  { id: 'p26', title: 'Traditional Cupcake Tattoo', image: images.cupcake, artist: 'Kelsi' },
  { id: 'p27', title: 'Spooky Girl Tattoo', image: images.knight, artist: 'Janet' },
  { id: 'p28', title: 'Snake And Skull Tattoo', image: images.snake, artist: 'Rain' },
  { id: 'p29', title: 'Skull Spider Tattoo', image: images.skull, artist: 'Rain' },
  { id: 'p30', title: 'Skull Coffin Tattoo', image: images.skull, artist: 'Rain' },
  { id: 'p31', title: 'Reflective Knives Tattoo', image: images.knight, artist: 'Coob' },
  { id: 'p32', title: 'Cartoon Tattoo', image: images.cupcake },
  { id: 'p33', title: 'Traditional Cupcake Tattoo', image: images.cupcake, artist: 'Kelsi' },
  { id: 'p34', title: 'Cutie Ice Cream Tattoo', image: images.cupcake, artist: 'Kelsi' },
  { id: 'p35', title: 'Xman Colton X Man Arm Tattoo', image: images.knight },
  { id: 'p36', title: 'Sunflowers Flowers Yellow Arm Tattoo Artwork', image: images.sunflower },
  { id: 'p37', title: 'Kemer Uvijek i Zauvijek Shield Tattoo', image: images.knight },
  { id: 'p38', title: 'Girl Playing Aeroplane Arm Tattoo', image: images.cupcake },
  { id: 'p39', title: 'Girl Player Game Tattoo Shoulder', image: images.heart },
  { id: 'p40', title: 'Girl Mesial American Weapon Tattoo Art', image: images.snake },
  { id: 'p41', title: 'Fish Flower Colorful Tattoo Artwork', image: images.fish, artist: 'Rick Trip' },
  { id: 'p42', title: 'Eye Flower Blood Teeth Arm Tattoo', image: images.sunflower },
];
